var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:['custom-button'],style:({
  border: _vm.border,
  backgroundColor: _vm.background,
  color: _vm.textColor
  }),attrs:{"loading":_vm.loading,"disabled":_vm.loading || _vm.inProgress,"text":""},on:{"click":function (e) { return _vm.handleClick(e); }}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }